import { useMemo, useState } from 'react'
import { useNavigate } from 'react-router'
import { ROUTE_DISBURSEMENTS } from '@klear/constants'
import { Card } from '@klear/ui/components/card'
import type { WizardStepGroupNavState } from '@klear/ui/wizard/nav-state'
import { useWizardDirtyLeaveGuard } from '@klear/ui/wizard/dirty-leave-guard'
import { Wizard } from '@klear/ui/wizard/wizard'
import { DISBURSEMENT_TYPE_LABELS } from '@/app/disbursements/steps'
import { DisbursementWizardLayout, useDisbursementOutletContext } from '@/app/disbursements/outlet-context'
import { DisbursementFlow } from '@/app/disbursements/disbursement-flow'
import { useDocumentTitle } from '@klear/ui/hooks/use-document-title'

function DisbursementWizardInner() {
  const navigate = useNavigate()
  const { state } = useDisbursementOutletContext()
  const [nav, setNav] = useState<WizardStepGroupNavState | null>(null)
  const { LeaveConfirmDialog, guardExit } = useWizardDirtyLeaveGuard({
    when: state.selectedAdvanceIds.length > 0
  })
  const guardedExit = useMemo(() => guardExit(() => navigate(`/${ROUTE_DISBURSEMENTS}`)), [guardExit, navigate])

  return (
    <div className="h-full min-h-0">
      {LeaveConfirmDialog}
      <Wizard
        name={DISBURSEMENT_TYPE_LABELS[state.disbursementType]}
        steps={nav?.steps ?? []}
        activeStepId={nav?.activeStepId ?? ''}
        onStepSelect={nav?.onStepSelect}
        isStepDisabled={nav?.isStepDisabled}
        onBack={guardedExit}
        contentMaxWidthClass="max-w-6xl"
      >
        <Card className="p-6">
          <DisbursementFlow onNavStateChange={setNav} />
        </Card>
      </Wizard>
    </div>
  )
}

export default function DisbursementWizard() {
  useDocumentTitle('New Disbursement')
  return (
    <DisbursementWizardLayout>
      <DisbursementWizardInner />
    </DisbursementWizardLayout>
  )
}
